export const JURNAL = 'JURNAL_';
export const JURNAL_PROCES = "JURNAL_PROCES"
export const JURNAL_OUT = "JURNAL_OUT"